const CheckRadioOnIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<rect x="1" y="1" width="12" height="12" strokeWidth="2" />
		<circle cx="7" cy="7" r="2" fill="currentColor" />
	</svg>
)

export default CheckRadioOnIcon